import React from 'react';
import { DynamicImage } from 'src/shared/design-system/DynamicImage';
import { WavyEdge } from 'src/shared/design-system/WavyEdge';
import styled from 'styled-components';
import { Border, Colors, Font, Spacing } from 'web-common/src/shared/styles';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  font-family: ${Font.Family.SANS};
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;

  background: ${Colors.WHITE};
  border: 1px solid ${Colors.GRAY_LITE_20};
  border-radius: ${Border.Radius.M};

  cursor: pointer;
`;

const CategoryCardImageHeader = styled.div`
  position: relative;
`;

const CategoryCardImage = styled(DynamicImage)`
  width: 100%;
  border-radius: ${Border.Radius.M} ${Border.Radius.M} 0 0;
`;

const CategoryCardBody = styled.div`
  max-width: 100%;
  padding: ${Spacing.SINGLE_QUARTER} ${Spacing.SINGLE} ${Spacing.SINGLE};

  font-family: ${Font.Family.SANS};
  font-size: ${Font.Size.S};
  font-weight: ${Font.Weight.SEMI_BOLD};
`;

export type CategoryButtonProps = {
  label: string;
  image: any;
  sourceWidth: number;
  sourceHeight: number;
  imageWidth?: number;
  imageHeight?: number;
  className?: string;
  onClick?: () => void;
};

export const CategoryCard: React.FC<CategoryButtonProps> = ({
  className,
  image,
  imageWidth,
  imageHeight,
  sourceWidth,
  sourceHeight,
  label,
  onClick,
}) => {
  const alt = `CategoryCard-${label}`;

  return (
    <Container className={className} onClick={onClick}>
      <CategoryCardImageHeader>
        <CategoryCardImage
          src={image}
          alt={alt}
          width={imageWidth}
          height={imageHeight}
          sourceWidth={sourceWidth}
          sourceHeight={sourceHeight}
          effect={'opacity'}></CategoryCardImage>
        <WavyEdge />
      </CategoryCardImageHeader>
      <CategoryCardBody>{label}</CategoryCardBody>
    </Container>
  );
};
